import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';
// import base from '../base';
// import * as formatter from './formatter';
const baseUrl = '/v2/artist/sales';
/**
 *
 * @param {Object} params {program, date}
 */

export const listOnDemandDownloads = async (params, axiosConfig) => {
  const request = api.request('get', baseUrl, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  });
  return request;
};

/**
 *
 * @param {Object} params
 */
export const listOnDemandSales = async (params) => {
  params = params || {};
  params.program = 'on_demand';
  const request = api.request('get', baseUrl, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
  return request;

  /*
  const request = await base.meAPI.get(`/${base.ver}/artist/sales?language=${base.defaultLang()}${payload ? `&${base.toQueryString(payload)}` : ''}`)
    .then((res) => {
      let result = res.data;

      const onlyGetContent = _.get(option, 'contentOnly', false);
      if (onlyGetContent) {
        result = res.data.data;
      }

      return result;
    })
    .catch((err) => {
      console.error(err);
    });

  return request;

   */
};
/**
 *
 * @param {Object} params {per_page}
 * period_start=2019-12&period_end=2020-01&interval=month&event=product_viewed&group_by=media_type&program=on_demand
 */
export const listSalesEvents = async (params, axiosConfig) => {
  const url = '/v2/artist/sales/events';
  // const request = await base.meAPI.get(`/${base.ver}/artist/sales/events?language=${base.defaultLang()}${payload ? `&${base.toQueryString(payload)}` : ''}`)
  //   .then(res => res.data)
  //   .catch((err) => {
  //     console.error(err);
  //   });
  params = params || {};
  const request = api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  });

  return request;
};
/**
 *
 * @param {Object} params {per_page}
 * period_start=2019-12&period_end=2020-01&interval=month&event=product_viewed&group_by=media_type&program=on_demand
 */
export const listSalesEventsMock = async (params) => {
  const url = '/v2/artist/sales/events';
  params = params || {};
  const request = api.requestMock('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });

  return request;
};

/**
 *
 * @param {Object} params {per_page}
 * period_start=2019-10&period_end=2020-01&interval=month
 */
export const listSalesEarnings = async (params, axiosConfig) => {
  const url = '/v2/artist/sales/earnings';
  // const request = await base.meAPI.get(`/${base.ver}/artist/sales/earnings?language=${base.defaultLang()}${payload ? `&${base.toQueryString(payload)}` : ''}`)
  //   .then(res => res.data.data)
  //   .catch((err) => {
  //     console.error(err);
  //   });
  params = params || {};
  const request = api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  });

  return request;
};

/**
 *
 * @param {Object} params {per_page}
 * period_start=2019-10&period_end=2020-01&interval=month
 */
export const listSalesEarningsMock = async (params) => {
  const url = '/v2/artist/sales/earnings';
  params = params || {};
  const request = api.requestMock('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });

  return request;
};

/**
 *
 * @param {Object} payload {per_page}
 * period_start=2019-12&period_end=2020-01&event=product_viewed&interval=month&program=on_demand
 */
export const listSalesProducts = async (params, axiosConfig) => {
  const url = '/v2/artist/sales/products';
  // const request = await base.meAPI.get(`/${base.ver}/artist/sales/products?language=${base.defaultLang()}${payload ? `&${base.toQueryString(payload)}` : ''}`)
  //   .then(res => res.data)
  //   .catch((err) => {
  //     console.error(err);
  //   });
  params = params || {};
  const request = api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  });

  return request;
};



export const listSalesAllKeywords = async (params, axiosConfig) => {
  const url = '/v2/artist/sales/search-terms';
  // const request = await base.meAPI.get(`/${base.ver}/artist/sales/search-terms?language=${base.defaultLang()}${payload ? `&${base.toQueryString(payload)}` : ''}`)
  //   .then(res => res.data.data)
  //   .catch((err) => {
  //     console.error(err);
  //   });
  params = params || {};
  const request = api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  });

  return request;
};
